var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.790254 6.79025H9.61739L5.76095 10.6467C5.45275 10.9549 5.45275 11.4607 5.76095 11.7689C6.06915 12.077 6.56701 12.077 6.87521 11.7689L12.083 6.56108C12.3912 6.25288 12.3912 5.75502 12.083 5.44682L6.88311 0.231149C6.57491 -0.0770497 6.07705 -0.0770497 5.76885 0.231149C5.46065 0.539348 5.46065 1.03721 5.76885 1.34541L9.61739 5.20975H0.790254C0.355614 5.20975 0 5.56536 0 6C0 6.43464 0.355614 6.79025 0.790254 6.79025Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/next-arrow.64d7cb9cde0d4d31b373fe35285ae73a.svg";
export { ForwardRef as ReactComponent };